import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'
import patient from '../../stores/patient'

const Button = styled.button`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4rem 0 0 0;
  color: var(--gray);
  cursor: pointer;
  width: 100%;
  &:hover {
    color: var(--red);
  }
`

const Icon = styled.i`
  font-size: 1.5rem;
  margin-right: 1rem;
`

export default class RemovePatient extends Component {
  render() {
    return (
      <Button onClick={patient.remove}>
        <Icon className="fas fa-trash" />
        <Text str="titles.removePatient" />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/RemovePatient.js